import { styled, flexCenter } from '@unfold/theme';
import { Card } from '@unfold/card';

export const ColorsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(145px, 1fr));
  grid-gap: 25px;
  margin-top: 40px;
`;

export const AddCard = styled(Card)`
  ${flexCenter}
  transition: all 0.2s ease-in-out;
  cursor: pointer;

  &:hover {
    transform: scale(1.02);
  }
`;
